module.exports = __webpack_public_path__ + "img/6.38fa3872.jpg";